/**
 * AI Prompts — system prompts die elke AI-feature aansturen.
 */
import React from 'react';
import { Box } from '@mui/material';
import { SettingField, SectionHeader } from '../adminSettingsCommon';

export default function AIPrompts() {
  return (
    <Box>
      <SectionHeader
        title="AI prompts"
        subtitle="System prompts voor de AI-features. Bevatten gedragsregels en outputstructuur."
      />
      <SettingField
        settingKey="effie_system_prompt"
        label="Effie analyse — system prompt"
        multiline rows={15}
        helperText="System prompt voor de Effie campagne-analysetool. Bevat alle learnings en de JSON output structuur."
      />
      <SettingField
        settingKey="breakdown_system_prompt"
        label="Script breakdown — system prompt"
        multiline rows={12}
        helperText="System prompt voor scene breakdown generatie."
      />
      <SettingField
        settingKey="shotlist_system_prompt"
        label="Shotlist — system prompt"
        multiline rows={15}
        helperText="System prompt voor shotlist generatie. Gebruik {setup_context} als placeholder voor equipment/stijl context."
      />
    </Box>
  );
}
